import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getModifierDataById } from 'redux/actions/Menu/modifiers';

/**
 * `refreshKey` refetches the group without remounting, so a list showing its
 * options follows a save made while that list stayed on screen.
 */
const useModifierById = (id, refreshKey) => {
  const dispatch = useDispatch();
  const [currentModifier, setCurrentModifier] = useState(false);
  const [loadingModOpt, setLoadingModOpt] = useState(false);

  useEffect(() => {
    setLoadingModOpt(true);
    dispatch(getModifierDataById(id, { hydrateSoldOut: false }))
      .then((res) => {
        setCurrentModifier(res);
        setLoadingModOpt(false);
      })
      .catch(() => {
        setLoadingModOpt(false);
      });
  }, [id, refreshKey]);

  return { currentModifier, loadingModOpt, setCurrentModifier, setLoadingModOpt };
};

export default useModifierById;
